import { Form } from "react-bootstrap";

export default function RadioButton({
  name = "",
  id,
  isChecked = false,
  label = "",
  onChange,
  disabled = false,
}) {
  return (
    <Form.Check
      type="radio"
      inline
      name={name}
      id={id}
      checked={isChecked}
      label={label}
      onChange={onChange}
      disabled={disabled}
    />
  );
}
